export default {
	title: "Vip レベル",
	current: "現在VIPレベル",
	status: {
		btn: ["開通済み", "今すぐ登録"]
	}
};
